<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <!-- <boton-atras :nombre_ruta="'informesSHaciendaConac'"/> -->
          <div class="container mt-1 mb-1 text-right">
            <router-link to="/armonizacionContable/menu" class="btn btn-vino-o" style="border-radius:22px;"> <!--:to="{name:nombre_ruta}"-->
                <i class="fas fa-arrow-left"></i> Atrás
            </router-link>
          </div>
        </div>
        <div class="container text-center mb-4">
            <h1 class="bold300 text-uppercase" style=" font-weight:500;">Informes Secretaría de Finanzas (Formatos CONAC)</h1>
        </div>
          <div v-for="(link, index) in links" :key="index" class="col-md-6">
            <a v-if="link.type === 'external'" :href="link.url" target="_blank"><cardsMenu  :card="link"/></a>
            <router-link v-else :to="{name: link.route}"><cardsMenu  :card="link"/></router-link>
          </div>
      </div>
    <span v-html="DateFormatText('2017-05-11')"></span>
    </div>
  </div>
</template>
<script>
import cardsMenu from '../../components/cardsMenu.vue';
import botonAtras from './../button-atras'
import DateFormat from "@/mixins/dateFormatMixin.js";
export default {
name: 'MenuFormatosConac',
components: {cardsMenu, botonAtras},
mixins: [DateFormat],
data(){
  return {
    data: [],
    links: [
    {id: 1, esIcono: true, recurso: "fas fa-building", titulo: 'Secretaría de Finanzas', type: 'internal', route: 'SHacienda' },
    {id: 2, esIcono: true, recurso: "fas fa-users", titulo: 'Organismos Subsidiados', type: 'internal', route: 'organismosSubsidiados' },
    {id: 3, esIcono: true, recurso: "fas fa-hands-helping", titulo: 'Ayudas a la Ciudadanía', type: 'internal', route: 'ayudaCiudadania' },
    {id: 4, esIcono: true, recurso: "fas fa-money-bill-wave", titulo: 'Deuda Pública', type: 'internal', route: 'deudaPublica' },
    {id: 5, esIcono: true, recurso: "fas fa-wallet", titulo: 'Provisiones Salariales y Económicas', type: 'internal', route: 'provisionesSalarialesEconomicas' },
    {id: 6, esIcono: true, recurso: "fas fa-file-contract", titulo: 'Obligaciones', type: 'internal', route: 'obligaciones' },
    {id: 7, esIcono: true, recurso: "fas fa-city", titulo: 'Municipios', type: 'internal', route: 'municipios' },
    {id: 8, esIcono: true, recurso: "fas fa-chart-pie", titulo: 'Información Consolidada', type: 'internal', route: 'IFP-Entes-Publicos' }
    ]
  };
},

}
</script>
